<div class="modal-content">
  <div class="modal-body modal-padding">
    <h5>Confirm Delete</h5>
    <p *ngIf="data.type!=='folder_annotation_delete'" [innerHTML]="annotation_delete | sanitizeHtml"> {{data.type ===
      'delete'||data.type==='deleteFolder'?'Annotation':'bookmark'}}?</p>
    <p *ngIf="data.type==='folder_annotation_delete'" [innerHTML]="annotation_delete | sanitizeHtml"></p>
    <div class="button-wrapper">
      <button (click)="delete()" class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721"
        viewindex="0">
        Yes
      </button>
      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
